import cookies from "js-cookie";

export const SESSION_EXPIRY_KEY = "foodoor_token_expires_at";
export const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

export const getNext2amISTDate = (refDate = new Date()) => {
  const nowMs = refDate.getTime();
  const istMs = nowMs + IST_OFFSET_MS;
  const istDate = new Date(istMs);

  const istYear = istDate.getUTCFullYear();
  const istMonth = istDate.getUTCMonth();
  const istDay = istDate.getUTCDate();
  const istHour = istDate.getUTCHours();
  const istMinute = istDate.getUTCMinutes();
  const istSecond = istDate.getUTCSeconds();
  const istMillis = istDate.getUTCMilliseconds();

  const past2amToday =
    istHour > 2 ||
    (istHour === 2 && (istMinute > 0 || istSecond > 0 || istMillis > 0));

  const targetDay = past2amToday ? istDay + 1 : istDay;
  const targetIstMs = Date.UTC(istYear, istMonth, targetDay, 2, 0, 0, 0);

  const targetUtcMs = targetIstMs - IST_OFFSET_MS;
  return new Date(targetUtcMs);
};

export const isSessionExpired = () => {
  const token = cookies.get("foodoor_token");
  if (!token) return true;

  const expiryRaw = localStorage.getItem(SESSION_EXPIRY_KEY);
  if (expiryRaw) {
    const expiresAt = Number(expiryRaw);
    if (!isNaN(expiresAt) && Date.now() >= expiresAt) {
      return true;
    }
  }
  return false;
};

export const expireSession = () => {
  cookies.remove("foodoor_token");
  localStorage.removeItem("foodoor_token");
  localStorage.removeItem(SESSION_EXPIRY_KEY);
  try {
    localStorage.removeItem("foodoor_insights_cache_v1");
    localStorage.removeItem("foodoor_restaurant_dropdown_cache_v1");
    localStorage.removeItem("foodoor_picked_franchise");
  } catch (e) {}

  if (
    process.env.NODE_ENV !== "test" &&
    typeof window !== "undefined" &&
    window.location &&
    window.location.pathname !== "/login"
  ) {
    try {
      window.location.replace("/login");
    } catch (e) {
      window.location.href = "/login";
    }
  }
};

export const syncSessionExpiration = () => {
  const tokenRaw = cookies.get("foodoor_token");
  if (!tokenRaw) {
    localStorage.removeItem(SESSION_EXPIRY_KEY);
    return false;
  }

  const expiryRaw = localStorage.getItem(SESSION_EXPIRY_KEY);
  if (expiryRaw) {
    const expiresAt = Number(expiryRaw);
    if (!isNaN(expiresAt) && Date.now() >= expiresAt) {
      expireSession();
      return true;
    }
  }

  if (!expiryRaw || isNaN(Number(expiryRaw))) {
    const next2am = getNext2amISTDate();
    const expiresAtMs = next2am.getTime();
    localStorage.setItem(SESSION_EXPIRY_KEY, String(expiresAtMs));
    try {
      const parsed = JSON.parse(tokenRaw);
      cookies.set("foodoor_token", JSON.stringify(parsed), {
        expires: next2am,
        sameSite: "Lax",
      });
    } catch (e) {
      cookies.set("foodoor_token", tokenRaw, {
        expires: next2am,
        sameSite: "Lax",
      });
    }
  }

  return false;
};

export const startSessionWatcher = () => {
  if (typeof window === "undefined") return () => {};

  syncSessionExpiration();

  let timeoutId = null;

  const scheduleNextTimer = () => {
    if (timeoutId) clearTimeout(timeoutId);
    const expiryRaw = localStorage.getItem(SESSION_EXPIRY_KEY);
    if (!expiryRaw) return;
    const expiresAt = Number(expiryRaw);
    if (isNaN(expiresAt)) return;

    const delay = expiresAt - Date.now();
    if (delay <= 0) {
      handleCheck();
    } else if (delay < 2147483647) {
      timeoutId = setTimeout(() => {
        handleCheck();
      }, delay);
    }
  };

  const handleCheck = () => {
    if (isSessionExpired()) {
      expireSession();
    } else {
      syncSessionExpiration();
      scheduleNextTimer();
    }
  };

  scheduleNextTimer();

  const intervalId = setInterval(handleCheck, 15000);
  window.addEventListener("focus", handleCheck);
  document.addEventListener("visibilitychange", handleCheck);

  return () => {
    if (timeoutId) clearTimeout(timeoutId);
    clearInterval(intervalId);
    window.removeEventListener("focus", handleCheck);
    document.removeEventListener("visibilitychange", handleCheck);
  };
};
